import { euro, fmtDate, countryName } from "./shop";

const esc = (s) =>
  String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

export function printOrder(o) {
  const a = o.address;
  const rows = o.items
    .map((i) => `<tr><td>${esc(i.name)}${i.condition_label ? ` <span style="color:#444">(${esc(i.condition_label)})</span>` : ""}</td><td class="c">${i.quantity}</td><td class="r">${euro(i.price * i.quantity)}</td></tr>`)
    .join("");
  const html = `<!doctype html><html lang="it"><head><meta charset="utf-8"><title>Ordine ${esc(o.number)}</title>
<style>
@page { size: A4; margin: 16mm; }
* { box-sizing: border-box; }
body { font-family: Arial, Helvetica, sans-serif; color: #000; margin: 0; }
h1 { font-size: 22px; margin: 0 0 4px; }
.top { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.top img { height: 22mm; width: auto; }
.top .info { text-align: right; }
.muted { color: #444; font-size: 12px; }
.box { border: 2px solid #000; border-radius: 6px; padding: 14px 16px; margin-top: 16px; }
.label { font-size: 11px; text-transform: uppercase; letter-spacing: .08em; color: #444; margin-bottom: 6px; }
.addr { font-size: 20px; line-height: 1.45; font-weight: bold; }
table { width: 100%; border-collapse: collapse; margin-top: 6px; font-size: 14px; }
th, td { border-bottom: 1px solid #999; padding: 6px 4px; text-align: left; }
.c { text-align: center; } .r { text-align: right; }
.tot td { font-weight: bold; font-size: 16px; border-bottom: none; }
</style></head><body>
<div class="top"><img src="${window.location.origin}/logo-mc-sm.png" alt="MC">
<div class="info"><h1>MC Anime - Games - TCG &amp; Shop</h1>
<div class="muted">Ordine ${esc(o.number)} &middot; Data: ${esc(fmtDate(o.paid_at || o.created_at))}</div></div></div>
<div class="box"><div class="label">Destinatario</div>
<div class="addr">${esc(a.full_name)}<br>${esc(a.address)}<br>${esc(a.zip)} ${esc(a.city)}${a.province ? ` (${esc(a.province)})` : ""}<br>${esc(countryName(a.country))}</div>
<div style="margin-top:10px;font-size:15px">Tel: <b>${esc(a.phone)}</b> &nbsp; Email: <b>${esc(o.email)}</b></div></div>
<div class="box"><div class="label">Articoli</div>
<table><thead><tr><th>Articolo</th><th class="c">Quantità</th><th class="r">Importo</th></tr></thead><tbody>${rows}
<tr><td>Spedizione: ${esc(o.shipping.name)}</td><td class="c">1</td><td class="r">${euro(o.shipping.cost)}</td></tr>
<tr class="tot"><td>Totale</td><td></td><td class="r">${euro(o.total)}</td></tr></tbody></table></div>
<script>window.onload = function () { window.print(); };</script>
</body></html>`;
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.open();
  w.document.write(html);
  w.document.close();
  return true;
}
